import { AtButton, AtIcon, ActionType } from '@curran-catalog/curran-atomic-library'
import classNames from 'classnames'

export const EmptyView = ({ isLoading }: { isLoading: boolean }) => (
  <div className="flex flex-col pb-12 tw-justify-center h-[350px]">
    <div className="mb-6 mx-auto">
      <AtIcon type="basket-shopping" size={128} className={classNames(isLoading && 'animate-pulse')} />
    </div>
    <div className={classNames(isLoading && 'opacity-0', 'mx-auto transition delay-200 duration-300 ease-in')}>
      <p className="sm:text-center my-4 text-lg sm:text-xl">You don&apos;t have anything in your cart, yet.</p>
      <AtButton actionType={ActionType.OPEN_URL} className="w-full" actionValue="/catalog" label="Shop" />
    </div>
  </div>
)
